(() => {
  const root = document.querySelector('[data-card-search-root]');
  if (!root || root.dataset.cardReady) return;
  root.dataset.cardReady = 'true';
  const scope = root.closest('.shopify-section');
  const inputs = [...scope.querySelectorAll('[data-card-name]')];
  const panel = scope.querySelector('[data-card-results]');
  const status = panel.querySelector('[data-card-status]');
  const grid = panel.querySelector('[data-card-grid]');
  const more = panel.querySelector('[data-card-more]');
  const url = new URL(location.href);
  const term = url.searchParams.get('card_name') || '';
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’‘]/g, "'");
  const words = normalize(term).trim().split(/\s+/).filter(Boolean);
  const navigate = value => {
    const next = new URL(location.href);
    next.searchParams.delete('page');
    if (value.trim()) next.searchParams.set('card_name', value.trim());
    else next.searchParams.delete('card_name');
    location.assign(next.href);
  };
  inputs.forEach(input => {
    input.value = term;
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); navigate(input.value); }
    });
    input.addEventListener('input', () => inputs.forEach(other => { if (other !== input) other.value = input.value; }));
    const controls = input.closest('.luna-card-search');
    controls.querySelector('[data-card-search]').addEventListener('click', () => navigate(input.value));
    const clear = controls.querySelector('[data-card-clear]');
    clear.hidden = !term;
    clear.addEventListener('click', () => navigate(''));
  });
  if (!words.length) return;
  root.classList.add('luna-card-search-active');
  panel.hidden = false;
  status.textContent = 'Searching card names in ' + root.dataset.collectionTitle + '…';
  scope.querySelectorAll('[data-testid="products-count"] span').forEach(el => { el.textContent = 'Searching…'; });
  let matches = [], shown = 0;
  const showMore = () => {
    const fragment = document.createDocumentFragment();
    matches.slice(shown, shown + 24).forEach(card => fragment.append(card.cloneNode(true)));
    shown += Math.min(24, matches.length - shown);
    grid.append(fragment);
    more.hidden = shown >= matches.length;
  };
  more.addEventListener('click', showMore);
  const fetchPage = async page => {
    const request = new URL(location.href);
    request.searchParams.delete('card_name');
    request.searchParams.set('section_id', 'luna-collection-search-data');
    request.searchParams.set('page', String(page));
    const response = await fetch(request, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Search unavailable');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = document.querySelector('[data-card-data]');
    if (!data) throw new Error('Search unavailable');
    return data;
  };
  (async () => {
    try {
      const first = await fetchPage(1);
      if (Number(first.dataset.total) > 25000) throw new Error('Collection too large');
      const pages = Number(first.dataset.pages) || 1;
      const cards = [...first.querySelectorAll('[data-card-id]')];
      for (let page = 2; page <= pages; page++) {
        status.textContent = 'Searching ' + root.dataset.collectionTitle + '… ' + (page - 1) + ' of ' + pages;
        const data = await fetchPage(page);
        cards.push(...data.querySelectorAll('[data-card-id]'));
      }
      const seen = new Set();
      matches = cards.filter(card => {
        const name = normalize(card.dataset.cardTitle || '');
        if (seen.has(card.dataset.cardId) || !words.every(word => name.includes(word))) return false;
        seen.add(card.dataset.cardId);
        return true;
      });
      scope.querySelectorAll('[data-testid="products-count"] span').forEach(el => { el.textContent = matches.length + (matches.length === 1 ? ' item' : ' items'); });
      status.textContent = matches.length ? matches.length + ' matching cards in ' + root.dataset.collectionTitle : 'No card names match “' + term + '” in ' + root.dataset.collectionTitle + '. Try another name or clear your search.';
      showMore();
    } catch (error) {
      status.textContent = 'We couldn’t complete this collection search. Please try again or clear your search.';
      scope.querySelectorAll('[data-testid="products-count"] span').forEach(el => { el.textContent = 'Search unavailable'; });
    }
  })();
})();
